// packages/shared/src/data/fetchUserTypes.js
import axios from '../config/axios';

export default async function fetchUserTypes(token, { signal } = {}) {
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
  const res = await axios.get('/usertypes', { headers, signal });
  return res.data; // either [{...}] or { types:[...], settings:{...} }
}
